import { useState, useEffect } from 'react'
import { useTableMetadataStore } from '../../_stores'
import TableHeader from './_TableHeader.jsx'



function TableHeaders({ data, tableRef }) {
	const addColumn = useTableMetadataStore(state => state.addColumn)
	const setCoumns = useTableMetadataStore(state => state.setColumns)
	const columns = useTableMetadataStore(state => state.columns)

	const isRowSelectable = useTableMetadataStore(state => state.isRowSelectable)
	const [allRowsSelected, setAllRowsSelected] = useState(false)

	useEffect(() => {
		if (allRowsSelected) {
			tableRef.current.querySelectorAll('tbody tr:not([data-loader])').forEach(row => {
				if (row.select) row.select(true)
			})
		} else {
			tableRef.current.querySelectorAll('tbody tr:not([data-loader])').forEach(row => {
				if (row.select) row.select(false)
			})
		}
	}, [allRowsSelected])

	useEffect(() => {
		setCoumns([])
		data.forEach((header, index)=> addColumn({
			isVisible: true, ...header, index, 
		}))

		if(tableRef && tableRef.current) tableRef.current.columns = data
	}, [data])
	
	return (
		<thead>
			<tr>
				{isRowSelectable ? <th data-header="Select All"
				 className='!w-min'
				>
					<input type="checkbox" className="mt-1" checked={allRowsSelected} onChange={(e)=>{
						setAllRowsSelected(e.target.checked)
					}}/>
				</th> : null}
				{columns.map((header, index) => {
					return (
						header.isVisible ? <TableHeader key={index} data={header}></TableHeader> : null
					)
				})}
			</tr>
		</thead>
	)
}

export default TableHeaders